module.exports = __webpack_public_path__ + "img/edit-icon.6f7b9526.svg";